// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3W8IQ","footer":"styles_footer__2jZdZ","passCodeTooltip":"styles_passCodeTooltip__2Nr34"};